<template>
  <div class="scenario_bar">
    <p class="control">
      <button class="button is-primary" v-on:click="save(true)">
          <span class="icon">
            <i class="fa fa-floppy-o"></i>
          </span>
        <span>{{$t('common.actions.save')}}</span>
      </button>
      <button class="button is-light" v-on:click="cancel">
          <span class="icon">
            <i class="fa fa-times-circle"></i>
          </span>
        <span>{{$t('common.actions.close')}}</span>
      </button>
<!--      <button class="button is-primary">-->
<!--          <span class="icon">-->
<!--            <i class="fa fa-calculator"></i>-->
<!--          </span>-->
<!--        <span>Рассчитать стоимость</span>-->
<!--      </button>-->
<!--      <button v-if="scenario.isReady" class="button is-success is-outlined" :disabled="true">-->
<!--          <span class="icon">-->
<!--            <i class="fa fa-info"></i>-->
<!--          </span>-->
<!--        <span>Подготовлен</span>-->
<!--      </button>-->
<!--      <button v-else class="button is-danger is-outlined" :disabled="true">-->
<!--          <span class="icon">-->
<!--            <i class="fa fa-info"></i>-->
<!--          </span>-->
<!--        <span>Не подготовлен</span>-->
<!--      </button>-->
    </p>
  </div>
</template>

<script>

    import { mapGetters } from 'vuex'
    import BaseComponent from '../BaseComponent'

    const api = '/api/scenarios'
    const PROFILES_API = '/api/profiles'

    export default {
      extends: BaseComponent,
      // name: 'Control',
      props: ['name', 'campaignid', 'checkDuration', 'scenario'],
      computed: {
        ...mapGetters([
          'loadedScenario',
          'loggedId',
          'loggedUser',
          'authenticationToken'
        ])
      },
      methods: {
        prepareSecurityHeader() {
          console.log(this.authenticationToken)
          return {
            Authorization: `Bearer ${this.authenticationToken}`
          }
        },
        changeRoute: function (e) {
          this.$router.push({path: '/scenarios' + e.target.value})
        },
        load() {
          this.$http({
            url: api + '/' + this._props.name,
            headers: this.prepareSecurityHeader()
          }).then((response) => {
            // console.log('opening scenario ' + JSON.stringify(response.data))
            this.$emit('set', response.data)
          }).catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки сценария. ')
            this.$emit('setDefault')
          })
        },
        // checkAudioDuration() {
        //   this._props.checkDuration = true
        //   let len = document.querySelectorAll('audio').length
        //   for (let i = 0; i < len; i++) {
        //     if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
        //       this._props.checkDuration = this._props.checkDuration && (document.querySelectorAll('audio')[i].duration > 0)
        //     }
        //   }
        //   return this._props.checkDuration
        // },
        save (showMessage) {
          // if (this.checkAudioDuration()) {
          if (!this._props.scenario.id) {
            this.saveNew(showMessage)
          } else {
            this.update(showMessage)
          }
          // } else {
          //   this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности')
          // }
        },
        saveNew(showMessage) {
          this.$emit('initScenario', this._props.scenario)
          console.log('saving new scenario: ' + JSON.stringify(this._props.scenario))

          this.$http.post(api, this._props.scenario, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              if (showMessage) {
                this.openNotificationWithType('info', 'Сценарий сохранен')
              }
              this.$emit('set', response.data)
            }).catch((error) => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
            })
        },
        update(showMessage) {
          this.$emit('initScenario', this._props.scenario)
          console.log('updating scenario: ' + JSON.stringify(this._props.scenario))
          this.$http.put(api, this._props.scenario, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              if (showMessage) {
                this.openNotificationWithType('info', 'Сценарий сохранен')
              }
              this.$emit('set', response.data)
            }).catch((error) => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
            })
        },

        cancel() {
          if (!this.$props.campaignid) {
            this.$router.push('/scenarios/')
          } else {
            this.$router.push('/campaigns/' + this.$props.campaignid)
          }
        },

        loadState () {
          this.$http({
            url: PROFILES_API + '/activeState/' + this.loggedId,
            headers: this.prepareSecurityHeader()
          }).then((response) => {
            this.isActive = response.data
            if (!this.isActive) {
              openMessage({
                message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
                type: 'danger',
                showCloseButton: true
              })
            }
          }).catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].scenarios.errorToGetUserStatus)
          })
        }
      },
      created: function () {
        this.loadState()
        if (!this._props.name) {
          console.log('creating new scenario')
          this.$emit('setDefault')
        } else {
          console.log('loading scenario: ' + !this.$props.name)
          this.load()
        }
      }
    }
</script>

<style scoped>

  .scenario_bar {
    margin-top: 40px;
  }

</style>



// WEBPACK FOOTER //
// ScenarioSaver.vue?2b7105c7